<template>
  <div class="o-category-list">
    <div class="container">
      <div class="row">
        <template v-for="(categoryItem, index) in categories">
          <div :key="index" class="col-md-6 col-lg-4">
            <category-card :category="categoryItem" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryCard from '@/components/organisms/ShopCommerce/CategoryCard'

export default {
  name: 'CategoryList',
  components: {
    CategoryCard
  },
  props: {
    categories: {
      type: Array,
      default: () => {}
    },
  }
}
</script>
